import { change as changeFormValue } from 'redux-form';
import { connect } from 'react-redux';
import { getSelected } from '../utils/utils';
import ProductBundle from '../components/ProductBundle';
import * as allProducts from '../../products';
const onChange = (dispatch, _ref) => {
  let {
    form,
    options,
    isAncillaryBundlingEnabled
  } = _ref;
  return (_ref2, field) => {
    let {
      value
    } = _ref2;
    const selectedOption = options === null || options === void 0 ? void 0 : options.find(option => (option === null || option === void 0 ? void 0 : option.id) === value);
    const bundleProductIds = options.flatMap(option => option.features.map(feature => Number(feature.productTypeId)));
    const bundledProducts = Object.entries(allProducts).filter(product => bundleProductIds === null || bundleProductIds === void 0 ? void 0 : bundleProductIds.includes(product[1].id));
    if (isAncillaryBundlingEnabled) {
      const formSections = bundledProducts.map(_ref3 => {
        let [, product] = _ref3;
        return product.name;
      });
      formSections.forEach(formSection => dispatch(changeFormValue(form, `${formSection}.value`, '')));
    }
    dispatch(changeFormValue(form, field, {
      productsInSelection: bundledProducts.map(p => p[1].id),
      value: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.type,
      price: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.priceRaw,
      id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id
    }));
  };
};
const mapStateToProps = (state, _ref4) => {
  let {
    form
  } = _ref4;
  return {
    selectedValue: getSelected('ancillaryBundle', form)(state)
  };
};
const mapDispatchToProps = (dispatch, props) => ({
  onChange: onChange(dispatch, props)
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductBundle);
//# sourceMappingURL=ProductBundleContainer.js.map